import * as types from '../../../actions/actiontypes';

import initialState from '../../initialstate';
import _ from 'lodash';

export default function bulkRequestSelectedReducer(state = initialState.bulkRequestSelected, action) {
	switch (action.type) {
		case types.ADD_OR_REMOVE_REQUEST_ID_TO_BULK_LIST:
			if (state.some((sr) => sr.clientRequestID === action.selectedRequest.clientRequestID)) {
				const remainingSelectedRequests = state.filter(
					(sr) => sr.clientRequestID !== action.selectedRequest.clientRequestID
				);
				return remainingSelectedRequests;
			}
			const selectedRequest = _.cloneDeep(action.selectedRequest);

			return [...state, selectedRequest];
		case types.CLEAR_BULK_REQUEST_LIST:
			return [];
		case types.SET_LIST_OF_BULK_REQUESTS:
			const otherPagesSelectedRequests = state.filter(
				(request) => !action.requestList.some((r) => r.clientRequestID === request.clientRequestID)
			);

			if (action.isAllSelected) {
				return [...otherPagesSelectedRequests, ...action.requestList];
			}

			return otherPagesSelectedRequests;
		default:
			return state;
	}
}
